export const dropdownMenuContentClassNames = [
    '@z-50',
    '@min-w-40',
    '@overflow-hidden',
    '@rounded-lg',
    '@bg-grey-1',
    '@border',
    '@border-grey-2_3',
    '@p-1',
    '@text-grey-6',
    '@shadow-down6',
    'data-[state=open]:@animate-in',
    'data-[state=closed]:@animate-out',
    'data-[state=closed]:@fade-out-0',
    'data-[state=open]:@fade-in-0',
    'data-[state=closed]:@zoom-out-95',
    'data-[state=open]:@zoom-in-95',
    'data-[side=bottom]:@slide-in-from-top-2',
    'data-[side=left]:@slide-in-from-right-2',
    'data-[side=right]:@slide-in-from-left-2',
    'data-[side=top]:@slide-in-from-bottom-2',
    '[&_p]:@mb-0',
];
export const dropdownMenuSwitchItemClassNames = [
    '@relative',
    '@flex',
    '@cursor-default',
    '@select-none',
    '@items-center',
    '@rounded-sm',
    '@px-2',
    '@py-2',
    '@text-b2',
    '@outline-none',
    '@transition-colors',
    'active:@text-brand1-1',
    'data-[disabled]:@pointer-events-none',
    'data-[disabled]:@opacity-50',
];
export const dropdownMenuItemClassNames = [
    ...dropdownMenuSwitchItemClassNames,
    'hover:@bg-grey-2',
    'focus-visible:@bg-grey-2',
];
export const dropdownMenuCheckboxItemClassNames = [
    ...dropdownMenuItemClassNames,
    'data-[state=checked]:@text-brand1-1',
];
export const dropdownMenuChevronClassNames = [
    '@ml-auto',
    '@h-4',
    '@w-4',
];
export const dropdownMenuItemIndicatorClassNames = [
    '@ml-auto',
    '@flex',
    // '@h-4',
    // '@w-4',
    '@items-center',
    '@justify-center'
];
export const dropdownMenuCheckClassNames = [
    '@h-4',
    '@w-4',
];
export const dropdownMenuLabelClassNames = [
    '@px-2',
    '@pt-1',
    '@text-caption',
    '@text-grey-4_5'
];
export const dropdownMenuSeparatorClassNames = [
    '@h-px',
    '@my-1',
    '@bg-grey-2_3'
];
export const dropdownMenuShortcutClassNames = [
    '@ml-auto',
    '@text-caption',
    '@tracking-widest',
    '@text-grey-4'
];
